var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"pb-4"},[_c('b-col',{staticClass:"d-flex flex-column"},[(_vm.objects.length > 1)?_c('Pagination',{attrs:{"features":_vm.objects,"indexStart":_vm.selectedIndex},on:{"indexChanged":function($event){return _vm.$_onIndexChanged($event)}}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }